var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVisible)?_c('td',{class:{ 'text-end': _vm.right },attrs:{"nowrap":_vm.nowrap}},[_vm._t("default"),(!_vm.$slots.default)?_c('span',[_vm._v("--")]):_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }